import { render } from "./AdminOverview.vue?vue&type=template&id=9f0565e2&scoped=true&ts=true"
import script from "./AdminOverview.vue?vue&type=script&lang=ts"
export * from "./AdminOverview.vue?vue&type=script&lang=ts"

import "./AdminOverview.vue?vue&type=style&index=0&id=9f0565e2&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f0565e2"]])

export default __exports__